import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Breadcrumbs,
  Link as MuiLink
} from '@mui/material';
import { Link } from 'react-router-dom';

interface PageTemplateProps {
  title: string;
  breadcrumbs?: {
    label: string;
    path: string;
  }[];
  description?: string;
  children: React.ReactNode;
}

const PageTemplate: React.FC<PageTemplateProps> = ({ 
  title, 
  breadcrumbs = [], 
  description, 
  children 
}) => {
  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        {breadcrumbs.length > 0 && (
          <Breadcrumbs sx={{ mb: 3 }}>
            <MuiLink component={Link} to="/" color="inherit">
              Home
            </MuiLink>
            {breadcrumbs.map((item, index) => (
              <MuiLink 
                key={index}
                component={Link} 
                to={item.path}
                color={index === breadcrumbs.length - 1 ? 'textPrimary' : 'inherit'}
              >
                {item.label}
              </MuiLink>
            ))}
          </Breadcrumbs>
        )}
        
        <Typography 
          variant="h2" 
          component="h1" 
          sx={{ 
            mb: description ? 2 : 4,
            fontWeight: 700,
            color: theme => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
          }}
        >
          {title}
        </Typography>
        
        {description && (
          <Typography 
            variant="subtitle1" 
            color="text.secondary" 
            sx={{ mb: 4, maxWidth: 800 }}
          >
            {description}
          </Typography>
        )}
        
        <Paper 
          elevation={0} 
          sx={{ 
            p: 4, 
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider'
          }}
        >
          {children}
        </Paper>
      </Container>
    </Box>
  );
};

export default PageTemplate; 